<template>
  <div class="navspinner  text-center">
    <b-spinner
      v-for="variant in 3"
      :key="variant"
      variant="light  small"
      style="width: 0.7rem; height: 0.7rem;"
      type="grow"
    ></b-spinner>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.navspinner {
  position: absolute;
  right: 0;
  left: 0;
  top: 15px;
}
</style>
